// extracted by mini-css-extract-plugin
export default {"calculator":"App_calculator__qy7Mf"};